export default {
    messages: {
        user_invited: 'Pozivni email je poslat korisniku',
    },
    buttons: {
        invite: 'Pozovi',
        invite_company_user: 'Pozovite korisnika u kompaniju',
        change_role: 'Promeni ulogu',
    },
    fields: {
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
    },
    errors: {
        user_not_found: 'Korisnik nije pronađen',
        company_not_found: 'Kompanija nije pronađena',
        user_already_part_of_the_company: 'Korisnik je već deo kompanije',
    },
}
